import {useState} from 'react';

import Button from 'components/Button/Button';
import Checkbox from 'components/Checkbox/Checkbox';
import Icon from 'components/Icon/Icon';
import InfoTooltip from 'components/InfoTooltip/InfoTooltip';
import './TableRowActions.scss';

interface IProps {
  checked?: boolean;
  onCheck?: () => void;
  disabled?: boolean;
  infoDisabled?: boolean;
  details?: string;
}

const TableRowActions = ({
  checked = false,
  onCheck = () => {},
  disabled = false,
  infoDisabled = false,
  details = 'No details',
}: IProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="table-row-actions__actions">
      {showTooltip && (
        <div className="table-row-actions__tooltip">
          <InfoTooltip onClose={() => setShowTooltip(false)} text={details} />
        </div>
      )}
      <div className="table-row-actions__info">
        <Button variant="empty" disabled={infoDisabled} onClick={() => setShowTooltip(true)}>
          <Icon icon="info" />
        </Button>
      </div>
      <div className="table-row-actions__checkbox">
        <Checkbox disabled={disabled} type="primary" onChange={onCheck} checked={checked} />
      </div>
    </div>
  );
};

export default TableRowActions;
